// list the components to be loaded in vue pages
const coreComponents = {
  ActivityTypeView: () => import('../components/ActivityTypeView.vue'),
  BookLibrary: () => import('../components/BookLibrary.vue'),
  Compare: () => import('../components/Compare.vue'),
  Dendograph: () => import('../components/Dendograph.vue'),
  DimensionWidget: () => import('../components/DimensionWidget.vue'),
  Detail: () => import('../components/Detail.vue'),
  Editor: () => import('../components/Editor.vue'),
  GlassComp: () => import('../components/GlassComp.vue'),
  Glossary: () => import('../components/Glossary.vue'),
  GraphControls: () => import('../components/GraphControls.vue'),
  GraphExplore: () => import('../components/GraphExplore.vue'),
  GraphIndex: () => import('../components/GraphIndex.vue'),
  GraphExploreVR: () => import('../components/GraphExploreVR.vue'),
  GraphLibrary: () => import('../components/GraphLibrary.vue'),
  GutenbergLibrary: () => import('../components/GutenbergLibrary.vue'),
  G6FilterNode: () => import('../components/G6FilterNode.vue'),
  Help: () => import('../components/Help.vue'),
  IframeComponent: () => import('../components/IframeComponent.vue'),
  Information: () => import('../components/Information.vue'),
  LayoutController: () => import('../components/LayoutController.vue'),
  LinkedThoughts: () => import('../components/LinkedThoughts.vue'),
  LoaderSemantic: () => import('../components/LoaderSemantic.vue'),
  MiniExplore: () => import('../components/MiniExplore.vue'),
  NotesLibrary: () => import('../components/NotesLibrary.vue'),
  QuestLibrary: () => import('../components/QuestLibrary.vue'),
  RecentActivity: () => import('../components/RecentActivity.vue'),
  Recentevents: () => import('../components/Recentevents.vue'),
  SearchEngine: () => import('../components/SearchEngine.vue'),
  SettingsMain: () => import('../components/SettingsMain.vue'),
  SkillGraph: () => import('../components/SkillGraph.vue'),
  Snippet: () => import('../components/Snippet.vue'),
  ThoughtMap: () => import('../components/ThoughtMap.vue'),
  ThoughtMarkdown: () => import('../components/ThoughtMarkdown.vue'),
  Thoughtverse: () => import('../components/Thoughtverse.vue'),
  Thoughtversealt: () => import('../components/Thoughtversealt.vue'),
  Thoughtversecontrols: () => import('../components/Thoughtversecontrols.vue'),
  TreasureMarker: () => import('../components/TreasureMarker.vue'),
  Twitterfeed: () => import('../components/Twitterfeed.vue'),
  ThreeDModelViewer: () => import('../components/ThreeDModelViewer.vue'),
  UserProfileComp: () => import('../components/UserProfileComp.vue'),
  Videos: () => import('../components/Videos.vue'),
  VisitedGraphVR: () => import('../components/VisitedGraphVR.vue'),
  VisitedGraphAlt: () => import('../components/VisitedGraphAlt.vue'),
  WikiDataCard: () => import('../components/WikiDataCard.vue'),
  WolframComp: () => import('../components/WolframComp.vue'),
};

const coreComponentList = [
  {
    name: 'DimensionWidget',
    component: coreComponents.DimensionWidget,
    options: {
      title: 'Dimension',
      description: 'Dimension',
    },
  },
  {
    name: 'Glossary',
    component: coreComponents.Glossary,
    options: {
      title: 'Glossary',
      description: 'Glossary',
    },
  },
  {
    name: 'NotesLibrary',
    component: coreComponents.NotesLibrary,
    options: {
      title: 'Notes Library',
      description: 'View all your notes',
    },
  },
  {
    name: 'Videos',
    component: coreComponents.Videos,
    options: {
      title: 'Videos',
      description: 'View all your notes',
    },
  },
  {
    name: 'GraphIndex',
    component: coreComponents.GraphIndex,
    options: {
      title: 'Graph Index',
      description: 'TOC of graph',
    },
  },
  {
    name: 'TreasureMarker',
    component: coreComponents.TreasureMarker,
    options: {
      title: 'Treasure Marker',
      description: 'TreasureMarker',
    },
  },
  {
    name: 'QuestLibrary',
    component: coreComponents.QuestLibrary,
    options: {
      title: 'Quest Library',
      description: 'View all your Quests',
    },
  },
  {
    name: 'Help',
    component: coreComponents.Help,
    options: {
      title: 'Help',
      description: 'View all your Help',
    },
  },
  {
    name: 'ThoughtMap',
    component: coreComponents.ThoughtMap,
    options: {
      title: 'ThoughtMap',
      description: 'ThoughtMap',
    },
  },
  {
    name: 'Detail',
    component: coreComponents.Detail,
    options: {
      title: 'Detail',
      description: 'Edit and view your nodes',
    },
  },
  {
    name: 'Editor',
    component: coreComponents.Editor,
    options: {
      title: 'Editor',
      description: 'Edit you notes',
    },
  },
  {
    name: 'G6FilterNode',
    component: coreComponents.G6FilterNode,
    options: {
      title: 'G6FilterNode',
      description: 'G6Filter Node',
    },
  },
  {
    name: 'GraphLibrary',
    component: coreComponents.GraphLibrary,
    options: {
      title: 'Graph Library',
      description: 'View all your graph',
    },
  },
  {
    name: 'LinkedThoughts',
    component: coreComponents.LinkedThoughts,
    options: {
      title: 'Linked Thoughts',
      description: 'G6 Graph Wikidata',
    },
  },
  {
    name: 'GraphControls',
    component: coreComponents.GraphControls,
    options: {
      title: 'Graph Controls',
      description: 'control force graph with this component',
    },
  },
  {
    name: 'LayoutController',
    component: coreComponents.LayoutController,
    options: {
      title: 'Layout Controller',
      description: 'Edit your layout with this config',
    },
  },
  {
    name: 'WikiDataCard',
    component: coreComponents.WikiDataCard,
    options: {
      title: 'Data Card',
      description: 'Get information from wiki data',
    },
  },
  {
    name: 'WolframComp',
    component: coreComponents.WolframComp,
    options: {
      title: 'WolframComp',
      description: 'Results from WolframAlpha',
    },
  },
  {
    name: 'RecentActivity',
    component: coreComponents.RecentActivity,
    options: {
      title: 'Recent Activity',
      description: 'Gist of what people are doing',
    },
  },
  {
    name: 'Snippet',
    component: coreComponents.Snippet,
    options: {
      title: 'Snippet',
      description: 'Get categorised data from Wiki data',
    },
  },
  {
    name: 'Twitterfeed',
    component: coreComponents.Twitterfeed,
    options: {
      title: 'Twitter feed',
      description: 'Related tweets from Twitter',
    },
  },
  {
    name: 'Compare',
    component: coreComponents.Compare,
    options: {
      title: 'Compare',
      description: 'Compare your Widget',
    },
  },
  {
    name: 'Dendograph',
    component: coreComponents.Dendograph,
    options: {
      title: 'Dendograph',
      description: 'DendroGram Visualization',
    },
  },
  {
    name: 'ThreeDModelViewer',
    component: coreComponents.ThreeDModelViewer,
    options: {
      title: '3D Models',
      description: 'View in 3D',
    },
  },
  {
    name: 'Recentevents',
    component: coreComponents.Recentevents,
    options: {
      title: 'Recent events',
      description: 'View all your events',
    },
  },
  {
    name: 'SkillGraph',
    component: coreComponents.SkillGraph,
    options: {
      title: 'Skill graph',
      description: 'View all your skills',
    },
  },
  {
    name: 'BookLibrary',
    component: coreComponents.BookLibrary,
    options: {
      title: 'Book Library',
      description: 'View all your books',
    },
  },
  {
    name: 'MiniExplore',
    component: coreComponents.MiniExplore,
    options: {
      title: 'Mini Explore',
      description: 'Explore your idea',
    },
  },
  {
    name: 'Information',
    component: coreComponents.Information,
    options: {
      title: 'Information',
      description: 'Short Description for Explore',
    },
  },
  {
    name: 'Thoughtverse',
    component: coreComponents.Thoughtverse,
    options: {
      title: 'Thoughtverse',
      description: 'Immersive Exploration',
    },
  },
  {
    name: 'Thoughtversealt',
    component: coreComponents.Thoughtversealt,
    options: {
      title: 'Thoughtverse alt',
      description: 'Immersive Exploration in AR',
    },
  },
  {
    name: 'Thoughtversecontrols',
    component: coreComponents.Thoughtversecontrols,
    options: {
      title: 'Thoughtverse Controls',
      description: 'Graph Controls',
    },
  },

  {
    name: 'LoaderSemantic',
    component: coreComponents.LoaderSemantic,
    options: {
      title: 'LoaderSemantic',
      description: 'View all async calls',
    },
  },
  {
    name: 'GutenbergLibrary',
    component: coreComponents.GutenbergLibrary,
    options: {
      title: 'Gutenberg Library',
      description: 'View books from Gutenberg',
    },
  },
  {
    name: 'IframeComponent',
    component: coreComponents.IframeComponent,
    options: {
      title: 'IframeComponent',
      description: 'Dive into another world',
    },
  },
  {
    name: 'VisitedGraphVR',
    component: coreComponents.VisitedGraphVR,
    options: {
      title: 'Visited Graph VR',
      description: 'All visited Links in the last Day',
    },
  },
  {
    name: 'VisitedGraphAlt',
    component: coreComponents.VisitedGraphAlt,
    options: {
      title: 'Visited Graph Alt',
      description: 'All visited Links in the last Day 3D',
    },
  },
  {
    name: 'ThoughtMarkdown',
    component: coreComponents.ThoughtMarkdown,
    options: {
      title: 'Thought Markdown',
      description: 'Autogenerated Markdown from events',
    },
  },
  {
    name: 'GraphExplore',
    component: coreComponents.GraphExplore,
    options: {
      title: 'Graph Explore',
      description: 'GraphExplore',
    },
  },
  {
    name: 'SearchEngine',
    component: coreComponents.SearchEngine,
    options: {
      title: 'Search Engine',
      description: 'To search the Keyword',
    },
  },
  {
    name: 'GraphExploreVR',
    component: coreComponents.GraphExploreVR,
    options: {
      title: 'GraphExploreVR',
      description: 'GraphExploreVR',
    },
  },
];

const asscendingAlgoritm = (a, b) => a.name.localeCompare(b.name);
const coreComponentOptions = coreComponentList.sort(asscendingAlgoritm);
export { coreComponents, coreComponentOptions };
